import React, {useEffect} from 'react';
import { Modal } from "@mui/material";
import Fade from '@mui/material/Fade';
import View from '@modul-connect/shared/components/atoms/view'
import { H1, P } from '@modul-connect/shared/components/atoms/text'
import TextField from '@modul-connect/shared/components/molecules/textField'
import Button from '@modul-connect/shared/components/atoms/button';
import modal from '@modul-connect/shared/components/atoms/modal'

const ModalEditReservation = ({
    openModal,
    onClose,
    editReservation,
    existingRow,
    disabled,
    onSubmit
}) => {
    const [providerName, setProviderName] = React.useState(existingRow ? existingRow.provider : "Modul-System HH AB")
    const [fromCode, setFromCode] = React.useState(existingRow ? existingRow.from_code : 0)
    const [toCode, setToCode] = React.useState(existingRow ? existingRow.to_code : 100)
    const [errorProviderName, setErrorProviderName] = React.useState(false)
    const [section, setSection] = React.useState(existingRow?.section || "")
    const [description, setDescription] = React.useState(existingRow?.description || "")

    useEffect(() => {
        if(openModal) {
            setProviderName(existingRow ? existingRow.provider : "Modul-System HH AB")
            setErrorProviderName(false)
            setDescription(existingRow?.description || "")
            setSection(existingRow?.section || "")
            setToCode(existingRow ? existingRow.to_code : 100)
            setFromCode(existingRow ? existingRow.from_code : 0)
        }
    }, [openModal, existingRow])

    const isName = (name) => {
      if(!name) return false
      if(!name.trim().length) return false
      
      return true
    }

    const onSave = () => {
        let hasErrors = false
        setErrorProviderName(false)

        if(!isName(providerName)) {
          setErrorProviderName(true)
          hasErrors = true
        }

        if(hasErrors) {
            return
        }

        if (existingRow) {
          const data = {
            id: existingRow.id,
            provider: providerName,
            section: section,
            description: description
          }

          editReservation(data)
          onSubmit(data)
          onClose()
        }

    }

    return (
        <Modal
            open={ openModal }
            onClose={(event, reason) => {
              if (disabled && reason === 'backdropClick') {
                return
              }
              onClose()
            }}            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={"Update Reservation"}/>
                        </View>
                        <View extend={{...modal.content, display: 'flex', flexDirection: 'column', gap: '0px', marginTop: '0px', marginBottom: '0px' }}>
                            
                            {/* Row for Inputs */}
                            <View extend={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                                <View extend={{ flex: 1 }}>
                                    <TextField
                                        name="From"
                                        placeholder={existingRow ? existingRow.from_code : "0"}
                                        disabled={ true }
                                        value={fromCode}
                                    />
                                </View>
                                <View extend={{ flex: 1 }}>
                                    <TextField
                                        name="To"
                                        placeholder={existingRow ? existingRow.to_code : "100"}
                                        disabled={ true }
                                        value={toCode}
                                    />
                                </View>
                            </View>

                        </View>
                        <View extend={{ ...modal.content, marginTop: '0'}}>
                            <TextField
                                name="Provider Name"
                                placeholder="Modul-System HH AB"
                                disabled={ disabled }
                                error={errorProviderName}
                                onChange={e => setProviderName(e.target.value)}
                                value={providerName}
                            />
                            <TextField
                                name="Section"
                                placeholder="Battery"
                                disabled={ disabled }
                                onChange={e => setSection(e.target.value)}
                                value={section}
                            />
                            <TextField
                                name="Description"
                                placeholder=""
                                disabled={ disabled }
                                onChange={e => setDescription(e.target.value)}
                                value={description}
                            />
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg cancel disabled={ disabled } onClick={ () => onClose() }>
                                Cancel
                            </Button>
                            <Button noBg noPadding disabled={ disabled } onClick={ onSave }>
                                Submit
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalEditReservation;